module.exports = __webpack_public_path__ + "static/media/hot4.5cba4a66.png";